export default class User {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      email: null,
      firstname: null,
      lastname: null,
      password: null,
      isActive: true,
      roleIds: []
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      email: this.email,
      firstname: this.firstname,
      lastname: this.lastname,
      password: this.password,
      isActive: this.isActive,
      roleIds: this.roleIds
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/user/model.js